module.exports = __webpack_public_path__ + "static/media/home-hero-mobile@2x.5c38539d.jpg";